import React from "react";

const About = () => (
  <div className="max-w-6xl mx-auto px-6 py-16 text-gray-800 leading-relaxed">
    <h2 className="text-4xl font-extrabold text-blue-900 mb-10 border-b-4 border-blue-200 pb-3">
      About <span className="text-blue-700">Blue Shield Labs</span>
    </h2>

    <div className="space-y-8 text-lg">
      <p>
        <span className="font-semibold text-blue-800">Blue Shield Labs</span> is a
        next-generation technology and consulting firm specializing in{" "}
        <span className="font-medium text-gray-900">
          Recruitment Process Outsourcing (RPO), Data Analytics, Information
          Technology, and Business Transformation
        </span>{" "}
        services. Built on a foundation of innovation and expertise, we empower
        organizations to unlock measurable value, accelerate growth, and make
        intelligent, data-driven decisions.
      </p>

      <p>
        Guided by a leadership team with nearly a decade of proven experience in
        IT recruitment and strategic consulting, Blue Shield Labs unites a
        multidisciplinary group of{" "}
        <span className="italic">
          recruitment specialists, data scientists, engineers, and business
          strategists
        </span>
        . Together, we deliver integrated solutions that help enterprises of all
        sizes from agile startups to global corporations navigate the
        complexities of the digital era with clarity and confidence.
      </p>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-md shadow-sm">
        <p className="text-gray-700">
          With a growing presence across <strong>20+ countries</strong>,
          Blue Shield Labs is redefining how businesses leverage technology to
          achieve operational excellence. We combine advanced analytics,
          quantitative modeling, and deep industry intelligence to address
          mission-critical challenges across verticals such as{" "}
          <span className="font-medium">
            Operations, Marketing, Risk Management, and Supply Chain
            Optimization
          </span>
          .
        </p>
      </div>

      <p>
        Our approach blends <strong>strategic insight</strong> with{" "}
        <strong>technological innovation</strong>  enabling organizations to
        modernize their talent ecosystem, strengthen data-driven decision
        frameworks, and accelerate digital transformation initiatives. We are
        committed to building long-term partnerships that deliver tangible
        impact, measurable performance, and sustainable business outcomes.
      </p>

      <div className="text-center mt-12">
        <h3 className="text-2xl font-semibold text-blue-800 mb-4">
          Excellence is our Standard
        </h3>
        <p className="max-w-3xl mx-auto text-gray-700">
          At Blue Shield Labs, excellence is more than a goal it’s our way of
          life. We innovate with intent, deliver with precision, and inspire
          transformation across every engagement.
        </p>
        <p className="mt-6 text-xl font-bold text-blue-900 tracking-wide">
          We Lead. We Evolve. We Succeed.
        </p>
      </div>
    </div>
  </div>
);

export default About;
